<template><!--我的收益-->
  <div style="padding: 20px">
    <div class="div">1.聊天或收取礼物所得金币可以兑换为人民币提取到支付宝账号。</div>
    <div class="div">2.用户在平台收到的礼物将直接转换为金币，转换比例为礼物价格的70%。</div>
    <div class="div">3.提取金币数量最低200，最高不设限，每日最多可以提取3次。</div>
    <div class="div">
      4.提取的基础比例为200:1（200金币兑换1元人民币），提取比例会按照数量阶梯式增长。
    </div>
    <div class="div">5.提取时需要填写支付宝账号和支付宝所属用户的真实姓名(非昵称)，否则无法到账。</div>
    <div class="div">6.提交成功后将在工作时间内一小时内处理完成（节假日和凌晨时间段可能顺延至工作时间）。提取记录中可以查看提取状态或失败原因。</div>
    <div class="div">7.若用户有违反平台规则或破坏平台环境（机器人脚本/批量重复话语/随机文字聊天等）行为，平台有权利根据用户协议拒绝该账户的提现申请。</div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>
<style>

.div {
  margin-bottom: 10px;
}

</style>
